import React from 'react';
import { Button } from 'antd-mobile';
import loadingIcon from '../../assets/img/loading.png';
import { useDebounceFn } from 'ahooks';

import './index.scss';

interface AXButtonProps {
  children: React.ReactNode;
  onClick?: (e?: React.MouseEvent) => void;
  disabled?: boolean;
  loading?: boolean;
  loadingText?: string;
  className?: string;
  size?: 'small' | 'middle' | 'large';
  type?: 'primary' | 'text' | 'gray' | 'default' | 'light-primary';
  block?: boolean;
}

export default function AXButton({
  children,
  onClick = () => {},
  disabled = false,
  loading = false,
  loadingText = '',
  className = '',
  block = false,
  type = 'primary',
}: AXButtonProps) {
  const isDisabled = disabled;
  const displayText = loading ? loadingText : children;

  const customClassName = `ax-button ax-button-${type} ${isDisabled ? 'ax-button-disabled' : ''} ${className}`;

  const { run } = useDebounceFn(
    (e?: React.MouseEvent) => {
      if (loading) return;
      onClick?.(e);
    },
    {
      wait: 1000,
      leading: true,
      trailing: false,
    },
  );

  return (
    <Button className={customClassName} disabled={isDisabled} onClick={run} block={block}>
      {loading && (
        <img
          src={loadingIcon}
          width={33}
          height={33}
          alt="loading"
          className="w-16px h-16px inline-block mr-8px loading-icon"
        />
      )}
      {displayText}
    </Button>
  );
}
